import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { StandardUIService } from '../../services/standardui-service/standardui-service';

const INCIDENT_STATUS_CLASS: Record<string, string> = {
  Unresolved: 'unresolved',
  Resolved: 'resolved',
  'Closed-Disregard': 'closeddisregard',
  Reopen: 'reopen-sr',
  'Close-Resolved': 'closeresolved',
  Waiting: 'wating-sr',
  Open: 'open-sr',
  'Close-Reclassify': 'close-reclassify'
};

@Component({
  selector: 'tr[qpVirtualRow]',
  templateUrl: './query-processor-virtual-row.component.html',
  host: { class: 'triggeropen' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QueryProcessorVirtualRowComponent {
  @Input() row: any[];
  @Input() rowIndex: number;
  @Input() offset: number;
  @Input() tabName: string;
  @Input() encCols: string;
  @Input() encRow: string;
  @Input() encCells: string[];
  @Input() indexColIsHash: boolean;
  @Input() multiselectChecked = false;
  @Input() disableEditButtons = false;
  /** Cumulative left offset (px) per column index — from query-processor recomputeStickyOffsetsFromWidths. */
  @Input() stickyLeftPx: number[] | null = null;
  @Input() stickyRightPx: number[] | null = null;
  @Input() fixedLeftCols = 0;
  @Input() fixedRightCols = 0;
  @Output() checkboxChange = new EventEmitter<Event>();

  constructor(public sus: StandardUIService) {}

  /** Horizontal sticky columns (API displayfixedpositionstart / end as left/right counts). */
  stickyCellStyle(colIdx: number): Record<string, string> | null {
    const n = this.stickyLeftPx?.length ?? 0;
    if (n === 0 || colIdx < 0 || colIdx >= n) {
      return null;
    }
    const leftN = this.fixedLeftCols || 0;
    const rightN = this.fixedRightCols || 0;
    const isLeft = colIdx < leftN;
    const isRight = rightN > 0 && colIdx >= n - rightN;
    if (!isLeft && !isRight) {
      return null;
    }
    const zBase = isLeft ? 3 + colIdx : 3 + (n - 1 - colIdx);
    const styles: Record<string, string> = {
      position: 'sticky',
      zIndex: String(Math.min(50, zBase))
    };
    if (isLeft && this.stickyLeftPx != null && this.stickyLeftPx[colIdx] != null) {
      styles['left'] = `${Math.round(this.stickyLeftPx[colIdx])}px`;
      styles['boxShadow'] = '4px 0 6px -4px rgba(0,0,0,0.12)';
    }
    if (isRight && this.stickyRightPx != null && this.stickyRightPx[colIdx] != null) {
      styles['right'] = `${Math.round(this.stickyRightPx[colIdx])}px`;
      styles['boxShadow'] = '-4px 0 6px -4px rgba(0,0,0,0.12)';
    }
    return styles;
  }

  onMultiselectCheckboxChange(ev: Event): void {
    this.checkboxChange.emit(ev);
  }

  statusClass(v: string): string {
    return INCIDENT_STATUS_CLASS[v] || '';
  }

  sanitizeOpen(v: any): string {
    return v?.toString()
      .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
      .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '') ?? '';
  }

  sanitizeTitle(v: any): string {
    return v?.toString()
      .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
      .replace(/&nbsp;|[^a-zA-Z0-9 @_. -]/g, '') ?? '';
  }

  casetypeImgSrc(value: string): string {
    return 'assets/images/casetypeImage/' + value.replace(/\s|\/+/g, '').toLowerCase() + '.svg';
  }

  formatDefaultCell(v: any): string {
    return v?.toString().replace(/,/g, ', ') ?? '';
  }
}
